import CursorCircle from "./cursor-circle";
import { disablePageScroll, enablePageScroll } from 'scroll-lock';
import { createFocusTrap } from 'focus-trap';
import WOW from 'wow.js';

export default {
    menu: null,
    open: null,
    close: null,
    status: null,
    delay: 50,
    duration: 750,
    durationOut: 400,
    OPEN_HEX: "#171717",
    CLOSE_HEX: "#FF385b",
    focus: null,
    /**
     * Opening and closing the global navigation menu.
     * @param {WOW} wow wow.js object to refresh animations on.
     * @param {CursorCircle} cursorCircle The cursor circle class to update when the menu is open
     * @param {String | HTMLElement} menu Selector or string for the menu
     * @param {String | HTMLElement} openBtn Selector or string for element that opens the menu
     * @param {String | HTMLElement} closeBtn Selector or string for element that closes the menu.
     */
    init(wow, cursorCircle = null, menu = '#menu', openBtn = '.btn--open', closeBtn = '.btn--close') {
        this.menu = this.getElement(menu);
        if(!this.menu) {
            console.warn("menu.js - Page doesn't contain the global menu");
        } else {
            this.focus = createFocusTrap(this.menu);
            this.open = this.getElement(openBtn);
            this.close = this.getElement(closeBtn);
            this.menuElements = Array.from(this.menu.querySelectorAll('.menu-item'));
            this.socialLinks = Array.from(this.menu.querySelectorAll('#menu__socials a'));
            this.wow = wow;

            //if we have a menu the page must not have both an open and a close button
            if(!this.open || !this.close) {
                throw new Error("menu.js - Page must have both a close and an oepn button for the menu (tip try" +
                    "parameter as a CSS selector e.g. .btn--close rather than btn--close)");
            }

            this.open.addEventListener('click', e => { this.menuOpen(cursorCircle) });
            this.close.addEventListener('click', e => { this.menuClosed(cursorCircle) });
        }
    },
    /**
     * Opening the menu when the menu button is clicked
     * @param {CursorCircle} cursorCircle The cursor circle class to update when the menu is open
     */
    menuOpen(cursorCircle) {
        this.status = true;
        this.menu.classList.add('active');
        disablePageScroll(this.menu);
        if(this.focus) {
            this.focus.activate();
        }
        if(this.menuElements) {
            this.menuElements.forEach((menuEl, i) => {
                let menuLink = menuEl.querySelector('a');
                if(menuLink) {
                    menuLink.className = "";
                    menuLink.removeAttribute('style');
                    menuLink.classList.add('animate__animated', 'animate__fadeInUp');
                    menuLink.style.animationDelay = (i * this.delay) + "ms"
                    menuLink.style.animationDuration = this.duration + "ms";
                }
            })
        }

        if(this.socialLinks) {
            this.socialLinks.forEach((socialLink, i) => {
                socialLink.className = "";
                socialLink.removeAttribute('style');
                socialLink.classList.add('animate__animated', 'animate__fadeIn');
                socialLink.style.animationDelay = "0ms"
                socialLink.style.animationDuration = this.duration + "ms";
            })
        }
        //changing colour of circle when the menu is open.
        if(cursorCircle) {
            cursorCircle.currentHex = this.OPEN_HEX;
            cursorCircle.options.hex = this.OPEN_HEX;
            cursorCircle.update();
        }
    },
    /**
     * Closing the menu when the close button is clicked
     * @param {CursorCircle} cursorCircle The cursor circle class to update when the menu is open
     */
    menuClosed(cursorCircle) {
        this.status = false;
        if(this.focus) {
            this.focus.deactivate();
        }

        if(this.menuElements) {
            this.menuElements.forEach((menuEl, i) => {
                let menuLink = menuEl.querySelector('a');
                if(menuLink) {
                    menuLink.className = ""
                    menuLink.removeAttribute('style');
                    menuLink.classList.add('animate__animated', 'animate__fadeOutDown');
                    menuLink.style.animationDelay = "0ms"
                    menuLink.style.animationDuration = this.durationOut + "ms";
                }
            })

            if(this.socialLinks) {
                this.socialLinks.forEach((socialLink, i) => {
                    socialLink.className = "";
                    socialLink.removeAttribute('style');
                    socialLink.classList.add('animate__animated', 'animate__fadeOut');
                    socialLink.style.animationDelay = "0ms"
                    socialLink.style.animationDuration = this.durationOut + "ms";
                })
            }

            window.setTimeout(() => {
                enablePageScroll(this.menu);
                this.menu.classList.remove('active');
            }, this.durationOut + 50);
        } else {
            enablePageScroll(this.menu);
            this.menu.classList.remove('active');
        }
        //changing colour of circle when the menu is closed.
        if(cursorCircle) {
            cursorCircle.currentHex = this.CLOSE_HEX;
            cursorCircle.options.hex = this.CLOSE_HEX;
            cursorCircle.update();
        }
    },
    /**
     * Get the element for the el if it is not already a HTMLElement.
     * @param el {String | HTMLElement} The element to retrieve
     * @return {HTMLElement} The element for the given string, or return the
     * input if it is already a HTMLElement.
     */
    getElement(el) {
        function isElement(element) {
            return element instanceof Element || element instanceof HTMLDocument;
        }

        if(isElement(el)) {
            return el;
        } else {
            return document.querySelector(el);
        }
    }
}